module.exports = __webpack_public_path__ + "media/Diagnose Ninon_neu_Stufe01.b4eb1fb6.mp4";